import * as React from 'react'
import BasicImage from '../FacetedCarousel/Card/Packshot/BasicImage'
import * as csm from '../../../utils/csm'
import * as style from './HeroElement.module.scss'
import * as playerStyles from './PlayerHover.module.scss'
import * as cn from 'classnames'
import PlayerHover from './PlayerHover'
import PreRollPlayer from './PreRollPlayer'
import checkUrlType from '../../../utils/url-type-checker'
import { StorefrontItem } from 'DVWebNodeUtils';

const BASELINE_SIZE = 1500

interface HeroElementProps {
  index?: number
  hasPrerollPlayer?: boolean
  item: StorefrontItem
  autoScrollFunc?: Function
  autoScrollDelayMilli?: number
  isActive?: boolean
  prerollMuteAction?: Function
  loadNow?: boolean
  formFactor: string
}

interface HeroElementState {
  playerVisibilityStyle: string
}

export class HeroElement extends React.PureComponent<HeroElementProps, HeroElementState> {
  index: number
  state: HeroElementState
  dvWebClientImgLoadFailure: Function

  components: {
    playerHoverComponent?: PlayerHover
    preRollPlayerComponent?: PreRollPlayer
  } = {}

  constructor(props: HeroElementProps) {
    super(props)
    this.index = props.index
    this.dvWebClientImgLoadFailure = () => {
      csm.count('dvWebClientImgLoadFailure')
    }

    this.state = {
      playerVisibilityStyle: playerStyles.imageUnBlur
    }
  }

  setImageVisibility(visible: boolean) {
    this.setState({
      playerVisibilityStyle: visible ? playerStyles.imageUnBlur : playerStyles.imageBlur
    })
  }

  render() {
    return (
      <a data-index={this.props.index} tabIndex={0}
        className={cn(style.content, style.imageWrapper, this.state.playerVisibilityStyle, 'tst-hero-element')}
        href={checkUrlType(this.props.item.link.url, 'HeroElement')} title={this.props.item.link.label || this.props.item.title}>
        <BasicImage alternateText={this.props.item.image.alternateText || this.props.item.title} url={this.props.item.image.url} onError={() => this.dvWebClientImgLoadFailure()}
          defaultWidth={BASELINE_SIZE}
        />
        {Boolean(this.props.hasPrerollPlayer) && <PlayerHover
          key={this.index}
          ref={(component) => {
            this.components.playerHoverComponent = component
          }}
          item={this.props.item}
          setImageVisibility={(visible: boolean) => this.setImageVisibility(visible)}
          preRollPlayerComponent={this.components.preRollPlayerComponent}
          formFactor={this.props.formFactor}
        >
          <PreRollPlayer
            item={this.props.item}
            ref={(component) => {
              this.components.preRollPlayerComponent = component
            }}
            autoScrollFunc={this.props.autoScrollFunc}
            autoScrollDelayMilli={this.props.autoScrollDelayMilli}
            isActive={this.props.isActive}
            prerollMuteAction={this.props.prerollMuteAction} />
        </PlayerHover>}
      </a>
    )
  }
}
